module.exports = __webpack_public_path__ + "static/media/data.460d2ef5.yml";